import {isRTL} from '../../../../../Localization';

const en = {
    save_btn_title: 'Save (Ctrl+S)',
    comment_btn_title: 'Add a Comment  (Ctrl+K)',
    picture_btn_title: 'Picture  (Ctrl+P)',
    hyperlink_btn_title: 'Hyperlink  (Ctrl+Q)',
    hline_btn_title: 'Horizontal Line  (Ctrl+H)',
    increase_indent_btn_title: 'Increase Indent  (Ctrl+>)',
    decrease_indent_btn_title: 'Decrease Indent  (Ctrl+<)',
    bullets_btn_title: 'Bullets  (Alt+B)',
    numbering_btn_title: 'Numbering  (Alt+N)',
    align_r_btn_title: 'Align Right  (Ctrl+R)',
    align_c_btn_title: 'Center  (Ctrl+M)',
    align_l_btn_title: 'Align Left  (Ctrl+L)',
    undo_btn_title: 'Undo  (Ctrl+Z)',
    underline_btn_title: 'Underline  (Ctrl+U)',
    italic_btn_title: 'Italic  (Ctrl+I)',
    bold_btn_title: 'Bold  (Ctrl+B)',
    txt_color_btn_title: 'Set Text Color  (Ctrl+O)',
    img_dialog_title: 'Insert Image',
    edit_link_label: 'Edit link',
    add_link_label: 'Add link',
    ok_label: 'Ok',
    unlink_label: 'Unlink',
    open_link: 'Open link',
    back_label: 'Back',
    image_upload_label: 'Upload image',
    image_alt_label: 'Description',
    confirm: 'Confirm',
    image_url: 'Image URL',
    file_label: 'File'
};

const he = {
    save_btn_title: 'שמור (Ctrl+S)',
    comment_btn_title: 'הוסף עדכון  (Ctrl+K)',
    picture_btn_title: 'תמונה  (Ctrl+P)',
    hyperlink_btn_title: 'היפר קישור  (Ctrl+Q)',
    hline_btn_title: 'קו הפרדה אופקי  (Ctrl+H)',
    increase_indent_btn_title: 'הקטן כניסה  (Ctrl+>)',
    decrease_indent_btn_title: 'הגדל כניסה  (Ctrl+<)',
    bullets_btn_title: 'תבליטים  (Alt+B)',
    numbering_btn_title: 'מיספור  (Alt+N)',
    align_r_btn_title: 'ישר לימין  (Ctrl+R)',
    align_c_btn_title: 'מרכז  (Ctrl+M)',
    align_l_btn_title: 'ישר לשמאל  (Ctrl+L)',
    undo_btn_title: 'בטל  (Ctrl+Z)',
    underline_btn_title: 'קו תחתון  (Ctrl+U)',
    italic_btn_title: 'נטוי  (Ctrl+I)',
    bold_btn_title: 'מודגש  (Ctrl+B)',
    txt_color_btn_title: 'קבע צבע  (Ctrl+O)',
    img_dialog_title: 'הוספת תמונה',
    edit_link_label: 'ערוך קישור',
    add_link_label: 'להוסיף קישור',
    ok_label: 'אישור',
    unlink_label: 'Unlink',
    open_link: 'פתח קישור',
    back_label: 'חזרה',
    image_upload_label: 'העלאת תמונה',
    image_alt_label: 'תיאור',
    confirm: 'בחירת קובץ',
    image_url: 'נתיב התמונה',
    file_label: 'קוֹבֶץ'
};

export const texts = isRTL() ? he : en;
